import { boolean, enums, object } from "superstruct";

import { WISHLIST_SOCIAL_SHARE_CHANNEL_NAMES } from "../constants/constants";

const WishlistsSocialShareChannelsSchema = object({
    channelName: enums(Object.values(WISHLIST_SOCIAL_SHARE_CHANNEL_NAMES)),
    isEnabled: boolean(),
});

export default WishlistsSocialShareChannelsSchema;
